import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { DetailExpandEvent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { MessageType } from '../../shared/enums/MessageType';
import { CommonParam } from '../../shared/models/CommonParam';

@Component({
    selector: 'dispatch-history',
    templateUrl: './dispatch-history.component.html',
    styleUrls: ['./dispatch-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchHistoryComponent extends BaseGridUIComponent<v_DispatchBus, null, DispatchesService>  {

    dispatchStatusFC: MSFilterClass = new MSFilterClass('dispatchStatusName');
    dispatchPriorityFC: MSFilterClass = new MSFilterClass('priorityName');

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
        this.aggregates = [{ field: 'dispatchStatusName', aggregate: 'count' }, { field: 'priorityName', aggregate: 'count' }];
        this.state.group = [{ field: 'dispatchStatusName', aggregates: this.aggregates }, { field: 'priorityName', aggregates: this.aggregates }];
    }
    onExpand(e: DetailExpandEvent) {
        if (!CommonFunctions.hasArrayElementValue(e.dataItem.dispatchNotes)) {
            this.svc_data.getNotesView(e.dataItem.dispatchId).subscribe(data => {
                e.dataItem.dispatchNotes = data;
            });

        }
    }
    details(data: v_DispatchBus) {
        this.showDQOI(data.dispatchId);
    }
    showMoreHistory() {
        this.sendParentMessage(MessageType.gotoDispatchHistory, null, null, null);

    }
    loadDispatchGeneric(value: any) {
        if (value.isConstruction) {
            if (value.isJob) {
                this.loadJob(value.dispatchId);
            }
            else {
                this.loadContract(value.dispatchId);
            }
        } else {
            this.loadDispatch(value.dispatchId);
        }
    }
    loadJob(id: any) {
        if (id) {
            let url: string = "/quickview/construction/10/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadContract(id: any) {
        if (id) {
            let url: string = "/quickview/construction/9/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadDispatch(id: any) {
        if (id) {
            let url: string = "/quickview/dispatch/1/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
        //this.router.navigateByUrl(url);
    }
    selectAllChanged(e: any) {
        let param: CommonParam = new CommonParam();
        param.addParam("ACTION", "GETPAGEDATA");
        param.addParam("CODE", "HISTORY");
        param.addParam("ID", null);
        param.addParam("ALL", e.target.checked);
        this.doParentActionParam(param);
    }
}
